var isSmoothScrollSupported = (function () {
    var isSupported = null;
    return function () {
        if (isSupported === null) {
            var testElement = document.createElement('div');
            // Close enough to javascript behavior: 'smooth' so we assume the support is the same
            testElement.style.setProperty('scroll-behavior', 'smooth');
            isSupported = testElement.style.scrollBehavior === 'smooth';
        }
        return isSupported;
    };
})();
var scrollBy = function (container, top, left) {
    if (isSmoothScrollSupported()) {
        container.scrollBy({
            top: top,
            left: left,
            behavior: 'smooth',
        });
    }
    else {
        var duration_1 = 500;
        var initialTop_1 = container instanceof Window ? container.scrollY : container.scrollTop;
        var initialLeft_1 = container instanceof Window ? container.scrollX : container.scrollLeft;
        var startTime_1 = new Date().getTime();
        var loop_1 = function () {
            requestAnimationFrame(function () {
                var currentTime = new Date().getTime();
                var progress = Math.min(1, (currentTime - startTime_1) / duration_1);
                var easedProgress = Math.pow(progress, 1.675); // Ease-in
                container.scrollTo({
                    top: initialTop_1 + easedProgress * top,
                    left: initialLeft_1 + easedProgress * left,
                    behavior: 'instant',
                });
                if (progress < 1) {
                    loop_1();
                }
            });
        };
        loop_1();
    }
};

export { scrollBy };
